import React from 'react';
import CountUp from 'react-countup';
import { useTranslation } from 'react-i18next';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { MarketButton } from '@market/react';
import QuantitySelector from 'components/common/quantity_selector';
import { displayVAT, toCurrency } from 'utilities/currency';
import { selectionPrice } from './helpers';

const ProductActions = (props) => {
  const {
    currentProduct,
    addOns,
    selection,
    requesting,
    setSelection,
    onAddToCartClick,
    eligiblePromotion,
  } = props;

  const { t } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));
  const isFree = currentProduct.sale_price_unformatted <= 0;

  return (
    <Box display="flex">
      <QuantitySelector
        value={selection.quantity}
        minimumValue={1}
        maximumValue={currentProduct.max_quantity}
        onValueChange={(newValue) =>
          setSelection({ ...selection, quantity: newValue })
        }
        ariaQuantityName={currentProduct.name}
      />
      <Box flexGrow={1} ml={2}>
        <MarketButton
          disabled={requesting || currentProduct?.shipping?.out_of_stock}
          data-testid="add-to-cart"
          id="add-to-cart"
          rank="primary"
          onClick={onAddToCartClick}
          style={{ width: '100%' }}
        >
          {t('productPage.addToCart')}
          {matches && !eligiblePromotion && (
            <>
              <Box component="span" mx={1}>
                {'•'}
              </Box>
              {isFree ? (
                t('productPage.free')
              ) : (
                <CountUp
                  style={{ fontVariantNumeric: 'tabular-nums' }}
                  start={currentProduct.sale_price_unformatted}
                  end={selectionPrice(currentProduct, addOns, selection)}
                  formattingFn={toCurrency}
                  decimals={2}
                  duration={0.3}
                  preserveValue
                />
              )}
              {displayVAT() && !isFree && (
                <span className="paragraph-10">
                  &nbsp;{t('common.plusVAT')}
                </span>
              )}
            </>
          )}
        </MarketButton>
      </Box>
    </Box>
  );
};

export default ProductActions;
